import { render, staticRenderFns } from "./ReminderBanner.vue?vue&type=template&id=8894fe18&scoped=true&"
import script from "./ReminderBanner.vue?vue&type=script&lang=js&"
export * from "./ReminderBanner.vue?vue&type=script&lang=js&"
import style0 from "./ReminderBanner.vue?vue&type=style&index=0&id=8894fe18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8894fe18",
  null
  
)

export default component.exports